import { SortedNeed } from "../utils";

import { Paragraph } from "App/global-style";
import { ProductBackendName } from "Features/CheckPrice/Products/productTypes";
import { useIsAdvisorSelector } from "Store/advisor/advisorSelectors";
import { CollectiveAdvice } from "Store/akaAdvice/interfaces/CollectiveAdvice";
import {
  areAllCoveragesAllowed,
  isAnyCoverageAllowed,
} from "Store/akaAdvice/interfaces/getters";
import { getFMSProductName } from "Store/texts/helpers/FMSproductName";
import { useProductTexts } from "Store/texts/hooks";
import React from "react";
import { StyledAdviceH3 } from "../../adviceStyled";
import { AdviceIntroMessages } from "../AkaAdviceMessages/AdviceIntroMessages";

interface Props {
  collectiveAdvice: CollectiveAdvice;
  sortedNeeds: SortedNeed[];
}

export const IndividualAdviceIntro = ({
  collectiveAdvice,
  sortedNeeds,
}: Props): React.ReactElement => {
  const [{ formText }, lang] = useProductTexts(
    getFMSProductName(ProductBackendName.ADVICE),
  );
  const isAdvisor = useIsAdvisorSelector();

  return (
    <>
      <StyledAdviceH3>
        {formText.advice.description.subHeader[lang]}
      </StyledAdviceH3>
      <Paragraph className="AdviceIntroText">
        {formText.advice.description.desc1[lang]}
      </Paragraph>
      {!isAdvisor && !areAllCoveragesAllowed(collectiveAdvice) && (
        <Paragraph className="AdviceIntroText">
          {formText.advice.description.contactUs[lang]}
        </Paragraph>
      )}
      <AdviceIntroMessages sortedNeeds={sortedNeeds} />
      {isAnyCoverageAllowed(collectiveAdvice) && (
        <StyledAdviceH3>
          {formText.advice.description.desc2[lang]}
        </StyledAdviceH3>
      )}
    </>
  );
};
